// removed by extract-text-webpack-plugin
module.exports = {"searchContainer":"searchBar_searchContainer_ZJGUB","lato-subtitle":"searchBar_lato-subtitle_2Hc6c global lato-subtitle","body":"searchBar_body_liBxG global body"};


//////////////////
// WEBPACK FOOTER
// ./src/component/header/searchBar/searchBar.css
// module id = 334
// module chunks = 4